import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { extract } from '@personal-area/global/i18n';

import { CardGuard } from './guards/card.guard';
import { ExpressGuard } from './guards/express.guard';
import { IdentityGuard } from './guards/identity.guard';
import { ResolveVerificationTypeGuard } from './guards/resolve-verification-type.guard';
import { VerificationBasicComponent } from './pages/basic/verification-basic/verification-basic.component';
import { EmailBasicComponent } from './pages/basic/email-basic/email-basic.component';
import { CardVerificationComponent } from './pages/card-verification/card-verification.component';
import { IdentityAutoComponent } from './pages/identity/identity-auto/identity-auto.component';
import { IdentityBannedComponent } from './pages/identity/identity-banned/identity-banned.component';
import { IdentityManualComponent } from './pages/identity/identity-manual/identity-manual.component';
import { RouteComponent } from './pages/route/route.component';
import { USIdentityRejectedComponent } from './pages/identity/us-identity-rejected/us-identity-rejected.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    children: [],
    canActivate: [ResolveVerificationTypeGuard],
  },
  {
    path: 'route',
    component: RouteComponent,
    data: {
      title: extract('profile.title.verification'),
    },
  },
  {
    path: 'express',
    data: {
      title: extract('verification.routing.express'),
    },
    runGuardsAndResolvers: 'always',
    canActivate: [ExpressGuard],
    children: [
      { path: 'auto', component: VerificationBasicComponent },
      { path: 'email', component: EmailBasicComponent },
    ]
  },
  {
    path: 'identity',
    data: {
      title: extract('verification.routing.full'),
    },
    runGuardsAndResolvers: 'always',
    canActivate: [IdentityGuard],
    children: [
      { path: 'banned', component: IdentityBannedComponent },
      { path: 'auto', component: IdentityAutoComponent },
      { path: 'manual', component: IdentityManualComponent },
      { path: 'us-rejected', component: USIdentityRejectedComponent }
    ],
  },
  {
    path: 'card',
    component: CardVerificationComponent,
    canActivate: [CardGuard],
    data: {
      title: extract('profile.routing.card-verification'),
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VerificationGlobalRoutingModule {}
